import React from "react";
import { Icon } from "@mc/mc-legacy";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import "./LanguageSelector.scss";
import PropTypes from "prop-types";
import { i18n } from "./i18n";
import {brandTitle} from "./Message";

export class LanguageSelector extends React.Component<any, { open: boolean }> {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  static contextTypes = {
    language: PropTypes.shape({
      currLang: PropTypes.string,
      allowedLangs: PropTypes.arrayOf(PropTypes.string),
      setLang: PropTypes.func,
    }),
  };
  handleToggle = () => {
    const { open } = this.state;
    this.setState({
      open: !open,
    });
  };
  handleSelectLang = (lang) => {
    this.context.language.setLang(lang);
    document.title = brandTitle(lang);
  };

  render() {
    const { open } = this.state;
    const { language } = this.context;
if (!language || !language.allowedLangs || language.allowedLangs.length <= 1) {
            return null;
        }

        return (
      <Dropdown id={"lang"} key={1} className={"language-selector"} isOpen={open} toggle={this.handleToggle}>
        <DropdownToggle key={1}>
          { i18n(language.currLang, `Lang_${language.currLang}`)}
          <Icon icon={"chevron-down ml-1"} />
        </DropdownToggle>
        <DropdownMenu key={2}>
          {
            language.allowedLangs.map((lang) => {
              return (
                <DropdownItem
                  key={lang}
                  active={lang === language.currLang}
                  onClick={() => this.handleSelectLang(lang)}
                >
                  {i18n(language.currLang, `Lang_${lang}`)}
                </DropdownItem>
              );
            })}
        </DropdownMenu>
      </Dropdown>
    );
  }
}
